import React from "react";
import { Link } from "react-router-dom";

import SearchBar from "./SearchBar";

const Header = ({ title, links, search, onSearchSubmit, onSearchChange }) => {
  const renderSearch = () => {
    if (!search) {
      return null;
    }

    return <SearchBar onSubmit={onSearchSubmit} onChange={onSearchChange} />;
  };

  return (
    <div className="ui menu">
      <Link to="/" className="header item">
        {title}
      </Link>
      <div className="right menu">
        {links}
        {renderSearch()}
      </div>
    </div>
  );
};

Header.defaultProps = {
  title: "Title",
  search: false
};

export default Header;
